<template>
    <div>
        <b-modal
            id="cancel-review-process-popup"
            ref="modal"
            title="Cancel Review Process"
            size="sm"
            no-close-on-backdrop
            modal-class="hide-footer"
            hide-footer
            no-close-on-esc
            :hide-header-close="loading"
            @hidden="onHidden"
        >
            <p class="custom-risk-override">
                Are you sure you want to cancel review process? Once you cancel
                someone else can initiate review process.
            </p>
            <div class="col-md-12 action-buttons">
                <button
                    :class="['btn btn-primary', { disabled: loading }]"
                    type="submit"
                    @click="cancelReview()"
                >
                    <span class="btn-text">Confirm</span>
                    <span class="loader"></span>
                </button>
                <button
                    class="btn btn-link"
                    type="button"
                    :disabled="loading"
                    @click="onHidden"
                >
                    <span class="btn-text">Close</span>
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'

export default {
    data() {
        return {
            id: null,
        }
    },
    watch: {
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(val) {
            if (val) {
                this.onHidden()
            }
        },
    }, // End of watch
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'hidePopup', 'dataSegmentId', 'alertRecord']),
    }, // End of computed
    methods: {
        async cancelReview() {
            try {
                this.$store.commit('setLoading', true)

                let alert = this.alertRecord
                let params = {
                    id: alert._id,
                    dataSegmentId: this.dataSegmentId,
                }
                // cancel review process for this alert
                let resourceApi = new resource('alerts/cancel-review')
                let { data } = await resourceApi.update(params.id, params)
                if (data) {
                    await this.$store.commit('setAlertRecord', data.data)
                    this.$store.commit('setSuccess', data.message)
                }
                    this.$store.commit('setRefreshProfile', true)
                    await this.$router
                    .push({
                        name: 'customer-information',
                        params: {
                            id: data.data.customerId,
                        },
                    })
                    .catch(() => {})
            } catch (error) {
                this.$store.commit('setLoading', false)
                this.$store.commit('setError', error)
                console.log(error, 'There is an error on initiate review')
            }
        },

        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
    },
}
</script>
